"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var preLoaderColor = "#777777ff", Width = 200, Height = 200, AnimSpeed = 0.2;
var Preloader = /** @class */ (function (_super) {
    __extends(Preloader, _super);
    function Preloader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rad = 0;
        _this.ctx = null;
        _this.intervalId = 0;
        return _this;
    }
    Preloader.setUp = function (newColor, width, height, animSpeed) {
        if (newColor === void 0) { newColor = "#777777ff"; }
        if (width === void 0) { width = 200; }
        if (height === void 0) { height = 200; }
        if (animSpeed === void 0) { animSpeed = 0.2; }
        Width = width;
        Height = height;
        AnimSpeed = animSpeed;
        preLoaderColor = newColor;
    };
    Preloader.prototype.onCanvasCreated = function (canvas) {
        //Start animation
        if (canvas === null) {
            return;
        }
        /**@type {canvas} */
        this.rad = 0;
        this.ctx = canvas.getContext('2d');
        this.animate();
        clearInterval(this.intervalId);
        this.intervalId = setInterval(this.animate.bind(this), 10);
    };
    Preloader.prototype.componentWillUnmount = function () {
        clearInterval(this.intervalId);
    };
    Preloader.prototype.animate = function () {
        /**@type {canvas} */
        var canvas = this.ctx;
        canvas.clearRect(0, 0, Width, Height);
        canvas.strokeStyle = preLoaderColor;
        canvas.lineWidth = 3;
        canvas.beginPath();
        canvas.arc(Width / 2, Height / 2, Width / 4, this.rad, this.rad + Math.PI, false);
        canvas.stroke();
        canvas.beginPath();
        canvas.arc(Width / 2, Height / 2, Width / 4 - 2, this.rad - 1, (this.rad + Math.PI - 1), false);
        canvas.stroke();
        this.rad += AnimSpeed;
    };
    Preloader.prototype.render = function () {
        return (react_1.default.createElement("canvas", { style: { width: 100, height: 100, margin: 'auto', display: 'block' }, ref: this.onCanvasCreated.bind(this), width: Width, height: Height }));
    };
    return Preloader;
}(react_1.Component));
exports.Preloader = Preloader;
;
//# sourceMappingURL=PreLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/ui/PreLoader.js
// module id = 102
// module chunks = 0